import styled from "styled-components";
import { colors } from "colors";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputWrapper = styled.div`
  display: flex;
  
  input {
    width: 100%; // TODO figure out why it's needed ?
    font-size: 14px;
    padding: 10px;
    border-top: 1px solid ${colors.silver};
    border-right: 1px solid ${colors.silver};
    border-bottom: 1px solid ${colors.silver};
    border-left: 0;
    border-radius: 0 4px 4px 0;
    outline: none;
    line-height: normal;
    text-align: end;
  }
  
  input::placeholder {
    color: lightgrey;
    font-size: 14px;
  }
  input[disabled] {
    background-color: ${colors.alabaster};
    border: none;
  }
`;

export const Prefix = styled.span`
  padding: 10px;
  min-width: 16px;
  min-height: 16px;
  
  text-align: center;
  font-weight: bold;
  color: ${colors.slateGrey};
  background-color: ${colors.white};
  border-radius: 4px 0 0 4px;
  border: 1px solid ${colors.silver};
  
  &[disabled] {
    background-color: ${colors.alabaster};
    border: none;
 }
`;

export const Label = styled.label`
  font-size: 14px;
  color: ${colors.slateGrey};
 
  &[required] {
    ::after {
      content: " *";
      color: ${colors.strawberry};
    }
  }
`;
